// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"e5e7f2c9","186":"c4b13497","197":"467c90a4","566":"23715acd","800":"0d61abd0"}[chunkId] + ".chunk.js";
};